import { Modal, Form, Input, Button, Spin, Row, Col } from 'antd';
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

const PromptsModal = ({ isEditing=false, open, onCancel, onFinish, initialValues=null }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const intl = useIntl();


  useEffect(() => {
    if (isEditing && open && initialValues) {
      form.setFieldsValue(initialValues);
    } else if (!open) {
      form.resetFields();
    }
  }, [isEditing, open, initialValues, form]);

  const handleOk = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      await onFinish(values);
    } catch (info) {
      console.log('Validate Failed:', info);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onCancel();
  };

  const title = isEditing 
    ? <FormattedMessage id="AGENTS.PROMPTS.MODAL.UPDATE_PROMPT" /> 
    : <FormattedMessage id="AGENTS.PROMPTS.MODAL.CREATE_NEW" />;

  const submitButtonText = isEditing 
    ? <FormattedMessage id="AGENTS.HOME.UPDATE" /> 
    : <FormattedMessage id="AGENTS.HOME.CREATE" />;

  return (
    <Modal
      title={title}
      open={open}
      onCancel={handleCancel}
      destroyOnHidden
      width={600}
      footer={[
        <Button key="back" onClick={handleCancel}>
          <FormattedMessage id="AGENTS.HOME.CANCEL" />
        </Button>,
        <Button key="submit" type="primary" onClick={handleOk} disabled={loading}>
          {submitButtonText}
        </Button>,
      ]}
    >
      {loading ? (
        <div className="flex justify-center items-center h-[200px]">
          <Spin />
        </div>
      ) : (
        <Form form={form} layout="vertical" name="prompt_form" className="mt-4">
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                label={<FormattedMessage id="AGENTS.HOME.PROMPT_NAME" />}
                name="name"
                rules={[
                  { required: true, message: <FormattedMessage id="AGENTS.HOME.PROMPT_NAME_VALID_EMPTY_MESSAGE" /> },
                  { max: 100, message: <FormattedMessage id="AGENTS.HOME.PROMPT_NAME_VALID_MAX_LENGTH_MESSAGE" /> },
                ]}
              >
                <Input className='!hover:bg-white !focus:bg-white' placeholder={intl.formatMessage({ id: 'AGENTS.HOME.PROMPT_NAME_PLACEHOLDER' })} />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label={<FormattedMessage id="AGENTS.HOME.TEXT" />}
                name="text"
                rules={[
                  { required: true, message: <FormattedMessage id="AGENTS.HOME.TEXT_VALID_EMPTY_MESSAGE" /> },
                  { max: 100, message: <FormattedMessage id="AGENTS.HOME.TEXT_VALID_MAX_LENGTH_MESSAGE" /> },
                ]}
              >
                <Input.TextArea rows={4} className='!hover:bg-white !focus:bg-white' placeholder={intl.formatMessage({ id: 'AGENTS.HOME.TEXT_PLACEHOLDER' })} />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      )}
    </Modal>
  );
};

PromptsModal.propTypes = {
  isEditing: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  initialValues: PropTypes.object,
};

export default PromptsModal;
